import { FilterViewModel } from './filter-view.model';

export class MasterFilterModel {
    geographys: FilterViewModel[];
    countries: FilterViewModel[];
    regulators: FilterViewModel[];
    ruleTopics: FilterViewModel[];
    jurisdictions: FilterViewModel[];
    status: FilterViewModel[];

    constructor() {
        this.geographys = [];
        this.countries = [];
        this.regulators = [];
        this.ruleTopics = [];
        this.jurisdictions = [];
        this.status = [];
    }
}
